import { render } from "./completeRegister.vue?vue&type=template&id=764f2e21"
import script from "./completeRegister.vue?vue&type=script&lang=js"
export * from "./completeRegister.vue?vue&type=script&lang=js"

import "./completeRegister.vue?vue&type=style&index=0&id=764f2e21&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__